import { render, staticRenderFns } from "./FloatCard.vue?vue&type=template&id=6fdb9fc6&scoped=true&"
import script from "./FloatCard.vue?vue&type=script&lang=js&"
export * from "./FloatCard.vue?vue&type=script&lang=js&"
import style0 from "./FloatCard.vue?vue&type=style&index=0&id=6fdb9fc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb9fc6",
  null
  
)

export default component.exports